import { useEffect, useMemo } from 'react'

const SNAP_THRESHOLD = 5

const ALL_SNAP_DIRECTIONS = {
  top: true,
  right: true,
  bottom: true,
  left: true,
  center: true,
  middle: true
} as const

interface IUseSnapGuidelinesParams {
  itemId: string
  targetRef: React.RefObject<HTMLDivElement | null>
  targetRefsMap: React.MutableRefObject<Map<string, HTMLDivElement>>
  canvasWidth: number
  canvasHeight: number
  enabled?: boolean
}

export const useSnapGuidelines = ({
  itemId,
  targetRef,
  targetRefsMap,
  canvasWidth,
  canvasHeight,
  enabled = true
}: IUseSnapGuidelinesParams) => {
  useEffect(() => {
    if (!enabled) return
    const el = targetRef.current
    if (!el) return

    const map = targetRefsMap.current
    map.set(itemId, el)

    return () => {
      map.delete(itemId)
    }
  }, [itemId, targetRef, targetRefsMap, enabled])

  const horizontalGuidelines = useMemo(
    () => [0, canvasHeight / 2, canvasHeight],
    [canvasHeight]
  )

  const verticalGuidelines = useMemo(
    () => [0, canvasWidth / 2, canvasWidth],
    [canvasWidth]
  )

  const getElementGuidelines = (): HTMLDivElement[] => {
    const elements: HTMLDivElement[] = []
    targetRefsMap.current.forEach((el, id) => {
      if (id !== itemId) elements.push(el)
    })
    return elements
  }

  return {
    snappable: true,
    snapThreshold: SNAP_THRESHOLD,
    snapDigit: 0,
    isDisplaySnapDigit: false,
    horizontalGuidelines,
    verticalGuidelines,
    elementGuidelines: getElementGuidelines(),
    snapDirections: ALL_SNAP_DIRECTIONS,
    elementSnapDirections: ALL_SNAP_DIRECTIONS
  }
}
